import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59961f3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"padding":"20px"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "page-title" }, "Start uploading attachments", -1))
const _hoisted_3 = { class: "sub-title" }
const _hoisted_4 = { class: "question-activity" }
const _hoisted_5 = { class: "log-wrapper" }
const _hoisted_6 = {
  key: 0,
  class: "files-attached-wrapper"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "files-attached-text" }, "Files Attached", -1))
const _hoisted_8 = { class: "file-item" }
const _hoisted_9 = { class: "file-item-name" }
const _hoisted_10 = { class: "d-flex justify-content-end align-items-center" }
const _hoisted_11 = { class: "file-item-name file-item-extension" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "file-item-created-at" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, "Upload Successfully Complete.", -1))
const _hoisted_15 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_upload_page_progress = _resolveComponent("upload-page-progress")!
  const _component_upload_box = _resolveComponent("upload-box")!
  const _component_download_svg = _resolveComponent("download-svg")!
  const _component_remove_attachment_svg = _resolveComponent("remove-attachment-svg")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_the_modal = _resolveComponent("the-modal")!
  const _component_title_text = _resolveComponent("title-text")!
  const _component_confirm_delete_modal = _resolveComponent("confirm-delete-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("p", _hoisted_3, "This area allows you to attach relevant files for " + _toDisplayString(_ctx.name), 1),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_ctx.uploadProgress !== 100)
          ? (_openBlock(), _createBlock(_component_upload_page_progress, {
              key: 0,
              class: "mt-24",
              "percent-progress": _ctx.uploadProgress,
              state: ''
            }, null, 8, ["percent-progress"]))
          : (_openBlock(), _createBlock(_component_upload_box, {
              key: 1,
              class: "mt-24",
              text: "Select file to attach",
              onOnChosen: _ctx.onFileChosen
            }, null, 8, ["onOnChosen"]))
      ]),
      (_ctx.fileList.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileList, (file) => {
              return (_openBlock(), _createElementBlock("div", {
                key: file.id
              }, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(file.name), 1),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(file.name.substring(file.name.lastIndexOf('.') + 1).toUpperCase()), 1),
                    _createVNode(_component_download_svg, {
                      class: "download-svg",
                      onClick: ($event: any) => (_ctx.downloadFile(file, $event))
                    }, null, 8, ["onClick"]),
                    _createElementVNode("span", {
                      class: "file-item-remove",
                      onClick: ($event: any) => (_ctx.openDeleteModal(file.id, $event))
                    }, [
                      _createVNode(_component_remove_attachment_svg)
                    ], 8, _hoisted_12)
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.format(new Date(file.created_at), ' MMM d, yyyy')) + " at " + _toDisplayString(_ctx.format(new Date(file.created_at), 'hh:mmaa')), 1)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_the_modal, {
      "is-visible": _ctx.uploadCompletedModal.isOpen.value,
      onOnCancel: _ctx.uploadCompletedModal.close,
      onOnConfirm: _ctx.uploadCompletedModal.close
    }, {
      content: _withCtx(() => [
        _hoisted_14
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_base_button, {
          onClick: _ctx.uploadCompletedModal.close
        }, {
          default: _withCtx(() => [
            _createTextVNode("Back to Upload")
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["is-visible", "onOnCancel", "onOnConfirm"]),
    _createVNode(_component_the_modal, {
      "is-visible": _ctx.errorModal.isOpen.value
    }, {
      content: _withCtx(() => [
        _createVNode(_component_title_text, null, {
          default: _withCtx(() => [
            _createTextVNode("Your upload is failed!")
          ]),
          _: 1
        }),
        _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.errorMessage), 1)
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_base_button, {
          class: "mx-1",
          variant: "red",
          onClick: _ctx.errorModal.close
        }, {
          default: _withCtx(() => [
            _createTextVNode("Try Again")
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["is-visible"]),
    _createVNode(_component_confirm_delete_modal, {
      "is-open": _ctx.confirmDeleteFilesModal.isOpen.value,
      title: "This will delete this file",
      subtitle: "'Type DELETE' to remove this file.",
      "confirm-button-text": "Delete data",
      onOnConfirm: _ctx.importAndReplace,
      onOnCancel: _ctx.handleConfirmDeleteFilesModalClose
    }, null, 8, ["is-open", "onOnConfirm", "onOnCancel"])
  ]))
}